import ApiPreguntas from './ApiPreguntas';
import MenuAspirante from './MenuAspirante';
import MenuAlumno from './MenuAlumno';
import ResBotAlumno from './ResBotAlumno';
import ResBotAspirante from './ResBotAspirante';
import ResumenCorreo from './ResumenCorreo';
import EnvioCorreo from './EnvioCorreo';
import Encuesta from './Encuesta';
import VolverHandler from "./VolverHandler";
import ResetHandler from "./ResetHandler";

export const steps = [
  {
    id: 'welcome',
    message: '¡Hola! Soy Veni, el asistente de UAEM',
    trigger: 'opciones',
  },
  {
    id: 'opciones',
    message: '¿En qué puedo ayudarte?',
    trigger: 'pregunta_campo',
  },
  // {
  //   id: "opciones",
  //   message: "¿En qué puedo ayudarte?",
  //   trigger: "mainmenu",
  // },
  {
    id: "mainmenu",
    options: [
      { value: "1", label: "Legislación universitaria", trigger: "legislacionSubmenu" },
      { value: "2", label: "Normativa axiológica", trigger: "normativaSubmenu" },
      { value: "3", label: "Órgano Informativo Universitario", trigger: "menupregunta" },
    ],
  },

  // SUBMENÚ Legislación
  {
    id: "legislacionSubmenu",
    message: "Elige una categoría dentro de Legislación universitaria:",
    trigger: "legislacionOptions",
  },
  {
    id: "legislacionOptions",
    options: [
      { value: "1", label: "Ley orgánica", trigger: "menupregunta" },
      { value: "2", label: "Estatuto universitario", trigger: "menupregunta" },
      { value: "3", label: "Reglamentos generales", trigger: "menupregunta" },
      { value: "4", label: "Lineamientos vigentes", trigger: "menupregunta" },
      // { value: "5", label: "Acuerdos vigentes", trigger: "menupregunta" },
      { value: "volver", label: "⬅️ Volver al menú principal", trigger: "resetHandler" },
    ],
  },

  // SUBMENÚ Normativa
  {
    id: "normativaSubmenu",
    message: "Elige una categoría dentro de Normativa axiológica:",
    trigger: "normativaOptions",
  },
  {
    id: "normativaOptions",
    options: [
      { value: "1", label: "Código ético universitario", trigger: "menupregunta" },
      { value: "2", label: "Código de ética de los servicios de radiodifusión", trigger: "menupregunta" },
      { value: "3", label: "Código de conducta de los trabajadores", trigger: "menupregunta" },
      { value: "volver", label: "⬅️ Volver al menú principal", trigger: "resetHandler" },
    ],
  },

  // Preguntar
  {
    id: "menupregunta",
    message: "Escribe cuál es tu duda:",
    trigger: "pregunta_campo",
  },
  {
    id: "pregunta_campo",
    user: true,
    trigger: "pregunta_respbot",
  },
  {
    id: "pregunta_respbot",
    component: <ApiPreguntas />,
    asMessage: true,
    waitAction: true,
    trigger: "opciones",
  },

  // Post respuesta → seguir preguntando?
  {
    id: "preguntar",
    message: "¿Te gustaría preguntar algo más de este tema?",
    trigger: "pregunta-opciones",
  },
  {
    id: "pregunta-opciones",
    options: [
      { value: "Si", label: "Sí", trigger: "pregunta_campo" },
      { value: "No", label: "No", trigger: "volverHandler" },
    ],
  },

  // Volver (decide si regresa a submenu o menú principal)
  {
    id: "volverHandler",
    component: <VolverHandler />,
    waitAction: true,
  },

  // Resetear valores y regresar al menú principal
  {
    id: "resetHandler",
    component: <ResetHandler />,
    waitAction: true,
  },

  {
    id:'instruccion-aspirante',
    message:'Selecciona una opción',
    trigger:'menuaspirante',
  },
  {
    id:'menuaspirante',
    component: <MenuAspirante/>,
  },
  {
    id:'menuaspirante-resbot',
    component: <ResBotAspirante/>,
    asMessage: true,
  },
  {
    id:'instruccion-alumno',
    message:'Selecciona una opción',
    trigger:'menualumno',
  },
  {
    id:'menualumno',
    component: <MenuAlumno/>,
  },
  {
    id:'menualumno-resbot',
    component: <ResBotAlumno/>,
    asMessage: true,
  },
  {
    id: 'fin-consulta-pregunta',
    message: '¿Tu duda fue resuelta?',
    trigger: 'pregunta-opciones',
  },
  {
    id: 'opciones-no-pregunta',
    options:[
      { value: 'No', label: 'Hacer otra pregunta', trigger: 'menupregunta' },
      // { value: 'Si', label: 'Volver al menú principal', trigger: 'opciones' },
      { value: 'bye', label: 'Finalizar el chat', trigger: 'encuesta-chatbot' },
    ],
  },
  {
    id: 'fin-consulta',
    message: '¿Tu duda fue resuelta?',
    trigger: 'pregunta-opciones-aspirante',
  },
  {
    id:'pregunta-opciones-aspirante',
    options:[
      { value: 'Si', label: 'Si', trigger: 'satisfaccion' },
      { value: 'No', label: 'No', trigger: 'opciones-no-aspirante' },
    ],
  },
  {
    id: 'opciones-no-aspirante',
    options:[
      { value: 'menuprincipal', label: 'Volver al menú principal', trigger: 'opciones' },
      { value: 'backmenuasp', label: 'Volver al menú de aspirante', trigger: 'instruccion-aspirante' },
      { value: 'backmenualum', label: 'Volver al menú de alumno', trigger: 'instruccion-alumno' },
    ],
  },
  {
    id: 'consulta-correo',
    message: '¿Te gustaría enviar un correo en este momento?',
    trigger: 'opciones-consulta-correo',
  },
  {
    id:'opciones-consulta-correo',
    options:[
      {value:'si',label:'Si',trigger:'envio-correo'},
      {value:'no',label:'No',trigger:'fin-consulta'}
    ]
  },
  {
    id:'envio-correo',
    message: '¿Cuál es tu nombre?',
    trigger: 'correo_nombre_campo',
  },
  {
    id:'correo_nombre_campo',
    user:true,
    trigger: 'correo-direccion',
  },
  {
    id:'correo-direccion',
    message:'¿Cuál es tu correo electrónico?',
    trigger:'correo_direccion_campo',
  },
  {
    id:'correo_direccion_campo',
    user: true,
    validator:(value) =>{
      //eslint-disable-next-line
      const re = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
      if(!re.test(String(value).toLowerCase())){
        return 'Ingrese un correo valido';
      }
      return true;
    },
    trigger:'correo-mensaje',
  },
  {
    id:'correo-mensaje',
    message:'Redacta tu mensaje a continuación',
    trigger:'correo_mensaje_campo',
  },
  {
    id:'correo_mensaje_campo',
    user: true,
    trigger:'correo-resumen',
  },
  {
    id:'correo-resumen',
    message:'Genial!, Tu correo está listo para ser enviado',
    trigger:'review',
  },
  {
    id: 'review',
    component: <ResumenCorreo />,
    trigger: 'actualizacion',
  },
  {
    id: 'actualizacion',
    message: '¿Todos tus datos son correctos?',
    trigger: 'actualizacion-pregunta',
  },
  {
    id: 'actualizacion-pregunta',
    options: [
      { value: 'yes', label: 'Sí, enviar correo', trigger: 'enviar-correo' },
      { value: 'no', label: 'No, modificar correo', trigger: 'actualizacion-si' },
    ],
  },
  {
    id: 'actualizacion-si',
    message: '¿Qué campo quieres modificar?',
    trigger: 'actualizacion-campos',
  },
  {
    id: 'actualizacion-campos',
    options: [
      { value: 'nombre', label: 'Nombre', trigger: 'actualizacion-nombre' },
      { value: 'correo', label: 'Correo', trigger: 'actualizacion-correo' },
      { value: 'mensaje', label: 'Mensaje', trigger: 'actualizacion-mensaje' },
    ],
  },
  {
    id: 'actualizacion-nombre',
    update: 'correo_nombre_campo',
    trigger: 'correo-resumen',
  },
  {
    id: 'actualizacion-correo',
    update: 'correo_direccion_campo',
    trigger: 'correo-resumen',
  },
  {
    id: 'actualizacion-mensaje',
    update: 'correo_mensaje_campo',
    trigger: 'correo-resumen',
  },
  {
    id: 'enviar-correo',
    component: <EnvioCorreo />,
    trigger: 'opciones-no-aspirante',
    asMessage: true,
  },
  // {
  //   id: 'encuesta-chatbot',
  //   message: '¿Cómo calificarías tu experiencia utilizando el chatbot? (1 = Muy malo, 5 = Excelente)',
  //   trigger: 'encuesta-chatbot-respuestas',
  // },
  {
    id:'encuesta-chatbot-respuestas',
    options:[
      { value: '5', label: '5', trigger: 'satisfaccion' },
      { value: '4', label: '4', trigger: 'satisfaccion' },
      { value: '3', label: '3', trigger: 'satisfaccion' },
      { value: '2', label: '2', trigger: 'satisfaccion' },
      { value: '1', label: '1', trigger: 'satisfaccion' },
    ],
  },
  {
    id:'satisfaccion',
    component: <Encuesta />,
    trigger: 'fin-chatbot',
    asMessage: true,
  },
  {
    id:'fin-chatbot',
    message:' ¡Hasta pronto! ',
    end:true,
  },
  {
    id: 'encuesta-chatbot',
    component: <Encuesta />,
    asMessage: true,
    waitAction: true,
    trigger: 'fin-chat'
  },
  {
    id: 'fin-chat',
    message: 'Gracias por usar el servicio 😊',
    end: true
  }
];



